export const SET_LOADING = 'SET_LOADING 🏀';
export const SET_SELECTED_INDEX = 'SET_SELECTED_INDEX 🥎';
export const SET_OPTIONS = 'SET_OPTIONS ⚾';
